import React from "react";
import { connect } from 'react-redux';
import { CreateSurveyProps } from "../common/CreateSurveyProps";
import Loading from "../components/EditSurvey/loading";
import { ApplicationState } from '../store';
import * as CreateSurveyStore from '../store/CreateSurvey';

// interface WithLoadingProps {
//     loading: boolean;
// }

interface istate {
    canLoadUIFlag: number, // -1 = not loaded from server, 0 = cannot load, 1 = can load
}

const AdminHOC = <P extends object>(Component: React.ComponentType<P>)  => {

    class ExtendedComponent extends React.Component<P & CreateSurveyProps, istate> {
        
        componentDidMount() {
            
            this.props.FetchCanLoadUIFlag();
        }

        render() {
            const { ...props } = this.props;

            if (this.props.canLoadUIFlag === -1 || this.props.canLoadUIFlag === 0) {
                return (<Loading flag={this.props.canLoadUIFlag}></Loading>);
            }

            return (<Component {...props as P}/>)
        }
    };

    return connect(
        (state: ApplicationState) => state.createSurveyStore,
        CreateSurveyStore.actionCreators
    )(ExtendedComponent as any);
 }

export default AdminHOC;
